import { render, staticRenderFns } from "./CgOrder.vue?vue&type=template&id=345a0498&scoped=true"
import script from "./CgOrder.vue?vue&type=script&lang=js"
export * from "./CgOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345a0498",
  null
  
)

export default component.exports